import { createSlice } from "@reduxjs/toolkit";
import { getProjectThunk, getprojectByNumberThunk } from "./projectListThunk";

const initialState = {
    projectList: [],
    fetchList: [],
    status: "idle",
    error: null,
};


const ProjectListSlice = createSlice({
    name: "getProject",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        //get all projects  
        builder.addCase(getProjectThunk.pending, (state) => {
            state.status = "loading";
            state.error = null;
            state.projectList = [];
        });
        builder.addCase(getProjectThunk.fulfilled, (state, action) => {
            state.status = "succeeded";
            state.projectList = action.payload;
        });
        builder.addCase(getProjectThunk.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.error?.message || "Failed to fetch project list";
            state.projectList = [];
        });


        //get project by number
        builder.addCase(getprojectByNumberThunk.pending, (state, action) => {
            state.status = "loading";
            state.error = null;
            state.fetchList = [];
        })
        builder.addCase(getprojectByNumberThunk.fulfilled, (state, action) => {
            state.status = "succeeded";
            state.fetchList = action.payload;
        })
        builder.addCase(getprojectByNumberThunk.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.error?.message || "Failed to Create Project";
            state.fetchList = [];
        })

    },
});

export default ProjectListSlice.reducer;